// File Name: ScrollProgress.jsx

import React from "react";

import {
  motion,
  useScroll,
  useSpring,
} from "framer-motion";

export default function ScrollProgress() {

  const { scrollYProgress } =
    useScroll();

  const scaleX = useSpring(
    scrollYProgress,
    {
      stiffness: 120,
      damping: 26,
      mass: 0.25,
    }
  );

  return (
    <>

      {/* ===================================================== */}
      {/* MAIN PROGRESS BAR */}
      {/* ===================================================== */}

      <motion.div

        className="
          fixed

          top-0
          left-0
          right-0

          h-[3px]
          sm:h-[4px]

          z-[9999]

          origin-left

          pointer-events-none
        "

        style={{
          scaleX,

          background: `
            linear-gradient(
              90deg,

              #6D3B8C 0%,

              #9B4D96 35%,

              #C67BCF 70%,

              #E9B8F4 100%
            )
          `,

          boxShadow: `
            0 0 10px rgba(168,85,247,0.45),

            0 0 22px rgba(192,132,252,0.28),

            0 0 45px rgba(216,180,254,0.14)
          `,
        }}
      />

      {/* ===================================================== */}
      {/* SOFT TOP GLOW */}
      {/* ===================================================== */}

      <motion.div

        className="
          fixed

          top-0
          left-0
          right-0

          h-[8px]
          sm:h-[10px]

          z-[9998]

          origin-left

          blur-md

          opacity-60
          sm:opacity-70

          pointer-events-none
        "

        style={{
          scaleX,

          background: `
            linear-gradient(
              90deg,

              rgba(109,59,140,0.55),

              rgba(168,85,247,0.45),

              rgba(216,180,254,0.25)
            )
          `,
        }}
      />

      {/* ===================================================== */}
      {/* MOBILE SAFE SHADOW */}
      {/* ===================================================== */}

      <div
        className="
          fixed
          top-0
          left-0
          right-0

          h-px

          z-[9997]

          bg-white/5

          pointer-events-none
        "
      />

    </>
  );
}